module.exports = __webpack_public_path__ + "static/assets/8589d7e6689f31ec2c251be25ac95c1b.mp3";